<script>
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import forminput from "@/router/views/formcomponet/forminput.vue";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import formdate from "@/router/views/formcomponet/formdate.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import osozlesme from "@/models/osozlesme"; 
import useVuelidate from "@vuelidate/core";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, osozlesme],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
    };
  },
  components: {
    forminput, treeselect, Multiselect, formtextarea, formdate
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) { 
        if (this.AddEdit == "Add") {
          this.Post("osozlesme", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.osozlesmeData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("osozlesme", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.osozlesmeData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    Get() { },
  },

  computed: {
  
    uygulamaSelectOptions() {
      const arr = this.FormDataType?.Uygulamaids?.ComboDataArray
      if (!Array.isArray(arr)) return []

      return arr
        .filter(x => x && x.id)
        .map(item => ({
          value: String(item.id),
          label: item.label || ""
        }))
    }
  }
};
</script>
<template>
  <b-modal v-model="ModalOpen" id="osozlesme" size="lg" :title="this.AddEdit == 'Edit'
    ? 'Kayıt Düzenle'
    : 'Yeni Kayıt Ekle'
    " title-class="font-18" hide-footer>
    <Form @submit.prevent="onSubmit" v-if="FormData">


      <div class="row">

        <forminput class="col-lg-6" :FormDataType="FormDataType.Baslik" :Value="FormData.Baslik" :v="v$.FormData.Baslik"
          @input="FormData.Baslik = $event.target.value" /> 

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Birimid.FieldTitle"
          :key="FormData.Birimid">
          <treeselect :multiple="false" :options="FormDataType.Birimid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Birimid" />
          <treeselect-value :value="FormData.Birimid" />
        </b-form-group>

        <formdate class="col-lg-6" :FormDataType="FormDataType.Baslangictarihi" :Value="FormData.Baslangictarihi"
          :v="v$.FormData.Baslangictarihi" @input="FormData.Baslangictarihi = $event.target.value" />

        <formdate class="col-lg-6" :FormDataType="FormDataType.Bitistarihi" :Value="FormData.Bitistarihi"
          :v="v$.FormData.Bitistarihi" @input="FormData.Bitistarihi = $event.target.value" />  


        <forminput class="col-lg-6" :FormDataType="FormDataType.Tutar" :Value="FormData.Tutar" :v="v$.FormData.Tutar"
          @input="FormData.Tutar = $event.target.value" />  

        <b-form-group class="col-lg-6" :label="FormDataType.Uygulamaids.FieldTitle">
          <Multiselect v-model="FormData.Uygulamaids" mode="tags" :close-on-select="false" :searchable="true"
            :options="uygulamaSelectOptions" valueProp="value" label="label" trackBy="label" placeholder="Seçiniz..." />
        </b-form-group>

        
        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Belgeid.FieldTitle"
          :key="FormData.Belgeid">
          <treeselect :multiple="false" :options="FormDataType.Belgeid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Belgeid" />
          <treeselect-value :value="FormData.Belgeid" />
        </b-form-group>
 
        <formtextarea class="col-lg-12" :FormDataType="FormDataType.Aciklama" :Value="FormData.Aciklama"
          :v="v$.FormData.Aciklama" @input="FormData.Aciklama = $event.target.value" />
 

      </div>
      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
